export default __webpack_public_path__ + "static/media/lock.ee5a62f9.svg";